module.exports = __webpack_public_path__ + "img/close_square.7b5ede44.svg";